export enum ErrorMapping {

    CODE = "unknown error",

    //CODIGOS DEL SERVIDOR
    // "codeserver",
    CODE_SRV_0 = "codeserver",
    // "OK",
    CODE_SRV_1 = "OK",

    //1×× Informational
    // "Continue",
    CODE_100 = "Continue",
    // "Switching Protocols",
    CODE_101 = "Switching Protocols",
    // "Processing",
    CODE_102 = "Processing",

    CODE_0 = "Se expiró la sesión, por favor vuelva a logearse.",

    //2×× Success
    // "OK",
    CODE_200 = "OK",
    // "Created",
    CODE_201 = "Created",
    // "Accepted",
    CODE_202 = "Accepted",
    // "Non-authoritative Information",
    CODE_203 = "Non-authoritative Information",
    // "No Content",
    CODE_204 = "No Content",
    // "Reset Content",
    CODE_205 = "Reset Content",
    // "Partial Content",
    CODE_206 = "Partial Content",
    // "Multi-Status",
    CODE_207 = "Multi-Status",
    // "Already Reported",
    CODE_208 = "Already Reported",
    // "IM Used",
    CODE_226 = "IM Used",

    //3×× Redirection,
    // "Multiple Choices",
    CODE_300 = "Multiple Choices",
    // "Moved Permanently",
    CODE_301 = "Moved Permanently",
    // "Found",
    CODE_302 = "Found",
    // "See Other",
    CODE_303 = "See Other",
    // "Not Modified",
    CODE_304 = "Not Modified",
    // "Use Proxy",
    CODE_305 = "Use Proxy",
    // "Temporary Redirect",
    CODE_307 = "Temporary Redirect",
    // "Permanent Redirect",
    CODE_308 = "Permanent Redirect",

    //4×× Client Error
    // "Bad Request",
    CODE_400 = "problemas en el aplicativo. contacte al administrador",
    // "Unauthorized",
    CODE_401 = "No posee una sesión activa. Se redirigira al Login.",
    // "Payment Required",
    CODE_402 = "Payment Required",
    // "Forbidden",
    CODE_403 = "No posee permisos para realizar esta acción. contacte al administrador",
    // "No Found",
    CODE_404 = "No se pudo establecer comunicación con el servicio. Intente mas tarde o contacte al administrador",
    // "Method Not Allowed",
    CODE_405 = "Estamos presentando problemas en el aplicativo. contacte al administrador",
    // "Not Acceptable",
    CODE_406 = "Estamos presentando problemas en el aplicativo. contacte al administrador",
    // "Proxy Authentication Required",
    CODE_407 = "Estamos presentando problemas en el aplicativo. contacte al administrador",
    //"Request Timeout",
    CODE_408 = "Se ha agotado el tiempo de la petición, intentar nuevamente por favor",
    // "Conflict",
    CODE_409 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Gone",
    CODE_410 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Length Required",
    CODE_411 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Precondition Failed",
    CODE_412 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Payload Too Large",
    CODE_413 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Request-URI Too Long",
    CODE_414 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Unsupported Media Type",
    CODE_415 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Requested Range Not Satisfiable",
    CODE_416 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Expectation Failed",
    CODE_417 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "I'm a teapot",
    CODE_418 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Misdirected Request",
    CODE_421 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Unprocessable Entity",
    CODE_422 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Locked",
    CODE_423 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Failed Dependency",
    CODE_424 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Upgrade Required",
    CODE_426 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Precondition Required",
    CODE_428 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Too Many Requests",
    CODE_429 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Request Header Fields Too Large",
    CODE_431 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Connection Closed Without Response",
    CODE_444 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Unavailable For Legal Reasons",
    CODE_451 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",
    // "Client Closed Request",
    CODE_499 = "Estamos presentando problemas técnicos. Intente nuevamente por favor.",

    //5×× Server Error,
    // "Internal Server Error"
    CODE_500 = "Estamos presentando problemas técnicos. Intente mas tarde, si el problema persiste, contacte al administrador",
    // "Not Implemented"
    CODE_501 = "Estamos presentando problemas técnicos. Intente mas tarde, si el problema persiste, contacte al administrador",
    // "Bad Gateway",
    CODE_502 = "Estamos presentando problemas técnicos. Intente mas tarde, si el problema persiste, contacte al administrador",
    // "Service Unavailable",
    CODE_503 = "Estamos presentando problemas técnicos. Intente mas tarde, si el problema persiste, contacte al administrador",
    // "Gateway Timeout",
    CODE_504 = "Estamos presentando problemas técnicos. Intente mas tarde, si el problema persiste, contacte al administrador",
    // "HTTP Version Not Supported",
    CODE_505 = "Estamos presentando problemas técnicos. Intente mas tarde, si el problema persiste, contacte al administrador",
    // "Variant Also Negotiates",
    CODE_506 = "Estamos presentando problemas técnicos. Intente mas tarde, si el problema persiste, contacte al administrador",
    // "Insufficient Storage",
    CODE_507 = "Estamos presentando problemas técnicos. Intente mas tarde, si el problema persiste, contacte al administrador",
    // "Loop Detected",
    CODE_508 = "Estamos presentando problemas técnicos. Intente mas tarde, si el problema persiste, contacte al administrador",
    // "Not Extended",
    CODE_510 = "Estamos presentando problemas técnicos. Intente mas tarde, si el problema persiste, contacte al administrador",
    // "Network Authentication Required",
    CODE_511 = "Estamos presentando problemas técnicos. Intente mas tarde, si el problema persiste, contacte al administrador",
    // " Network Connect Timeout Error"
    CODE_599 = "Estamos presentando problemas técnicos. Intente mas tarde, si el problema persiste, contacte al administrador"
}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/recursos/modelo/consumerModel/error-mapping.enum.ts